import { useEffect, useState } from 'react';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import { GoAButton, GoACallout, GoASpacer } from '@abgov/react-components';
import styles from './onboarding.module.css';
import { REACT_CREATE_NEW_USER_URL } from '../../state/configuration';
import { WizardButtonGroup } from '../wizard/wizard-button-group-component';

interface RegisterComponentProps extends BaseWizardProps { }

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const RegisterComponent = ({
  navigationConfiguration,
}: RegisterComponentProps) => {
  const [nextPage, setNextPage] = useState('');
  useEffect(() => {
    const pageConfig = navigationConfiguration.pagingConfiguration.find(
      (item) => item.default !== undefined,
    );

    setNextPage(pageConfig?.default ?? 'error');
  }, []);

  const navigate = () => {
    if (REACT_CREATE_NEW_USER_URL) {
      window.open(REACT_CREATE_NEW_USER_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="contentbox">
      <GoASpacer vSpacing={'3xl'} />
      <GoACallout type="success" maxWidth="629px">
        Success, you meet the eligibility requirements to continue using the
        Report My Collision online service.
      </GoACallout>
      <h2 className={styles.header2}>Register for an Alberta.ca account</h2>
      <GoASpacer vSpacing="m" />

      <p>
        To use the Report My Collision online service, you’ll need to create an
        Alberta.ca account. Once your account is set up, you will be able to:
      </p>

      <ol className="goa-ordered-list">
        <li>Log into the service</li>
        <li>
          Answer the eligibility questions again (this ensures your answers are
          recorded with your account)
        </li>
        <li>Start a new collision report</li>
      </ol>
      <WizardButtonGroup
        nextPage={nextPage}
        // validate={validate}
        // save={save}
        showViewSummaryButton={false}
        navigate={navigate}
        buttonText={'Register Now'}
        buttonTrailingIcon="open"
      />
      {/* <GoASpacer vSpacing="2xl" />
      <GoAButton
        trailingIcon="open"
        onClick={() => {
          handleCreateNewAccountClick();
        }}>
        Register Now
      </GoAButton>
     <GoASpacer vSpacing="3xl" /> */}
    </div>
  );
};
